import dompurify from 'dompurify';
import xhrio from 'up.lib.js.xhrio';
import { v4 as v4uuid } from 'uuid';
import { Page } from '~src/domains/common/enums/api';
import { Doc } from '~src/domains/common/enums/docs';
import {
  setDocument,
  setIsProcessing,
  setMcode,
} from '~src/domains/common/state/commonReducer';
import { trackDocumentResponse } from '../tracking';
import { updateDisclosureForms } from './documents';

const GET = 'Get';
const XHR_TIMEOUT = 30000;

const sanitize = dompurify.sanitize;

const jsonpSuccessHandler =
  (id: Doc, data: string) => (dispatch: Function, getState: Function) => {
    const state = getState();
    const { page, document: currDoc } = state.common;

    dispatch(setMcode(null));

    switch (page) {
      case Page.START:
      case Page.ACCEPT:
      case Page.RECONFIRM:
      case Page.REACCEPT:
      case Page.ADVERSE:
        dispatch(
          setDocument({
            ...currDoc,
            show: true,
            content: data,
            loading: true,
          }),
        );

        dispatch(trackDocumentResponse(id, true));
        // translate document
        break;
      case Page.LOAN_CONSENT:
        if (currDoc.id === Doc.CSD) {
          dispatch(
            setDocument({
              ...currDoc,
              show: true,
              content: data,
              loading: false,
            }),
          );
        } else {
          dispatch(
            setDocument({
              ...currDoc,
              show: false,
              content: null,
              loading: false,
            }),
          );

          dispatch(updateDisclosureForms(id, data));
          dispatch(trackDocumentResponse(id, true));
        }
        break;
      default:
        dispatch(
          setDocument({
            ...currDoc,
            show: false,
            content: null,
            loading: false,
          }),
        );

        dispatch(trackDocumentResponse(id, true));
    }
  };

const jsonpFailHandler =
  (id: Doc) => (dispatch: Function, getState: Function) => {
    const state = getState();
    const currDoc = state.common.document;

    dispatch(trackDocumentResponse(id, false));
    dispatch(setMcode(52));
    dispatch(
      setDocument({
        ...currDoc,
        show: false,
      }),
    );
  };

const jsonpDoc = (url: string, id: Doc) => (dispatch: Function) => {
  const requestId = v4uuid();

  const errorHandler = () => {
    setTimeout(() => {
      dispatch(setIsProcessing(false));
      dispatch(jsonpFailHandler(id));
    }, XHR_TIMEOUT);
  };

  const successHanlder = ([res, _]: any) => {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = res;
    wrapper.innerHTML = wrapper.getElementsByTagName('div')[0].outerHTML;
    const sanitizedData = sanitize(wrapper.innerHTML);
    dispatch(jsonpSuccessHandler(id, sanitizedData));
    dispatch(setIsProcessing(false));
  };

  return xhrio(
    GET,
    url,
    {
      'Content-type': 'application/json',
    },
    JSON.stringify({}),
    successHanlder,
    errorHandler,
    () => {},
    requestId,
    XHR_TIMEOUT,
    errorHandler,
  );
};

export { jsonpDoc };
